import draggableUtility from '@sparta.community.utilities/draggable-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import * as pageTitleNotifier from '@sparta.global.utilities/page-title-notifier/dist/es6.js';
import spartaStoreUtility from '@sparta.global.utilities/sparta-store-utility/dist/es6.js';
import '@sparta.global.vendors/jquery';
import '@sparta.global.vendors/handlebars';
import '@sparta.global.vendors/lodash';
import focusTrapUtility from '@sparta.global.utilities/focus-trap-utility/dist/es6.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';

var constants = {
  SELECTORS: {
    chat: '.js-chat',
    chatCloseButton: '.js-chat-disconnect',
    chatMinimizeButton: '.js-chat-minus',
    chatHeader: '.js-chat-header',
    chatHeaderTitle: '.header__title-chat',
    chatLoadingAnimation: '.chat__loading-pane',
    chatMenuListItems: '.js-chat-menu-list-items',
    chatMenuToggle: '.js-chat-menu-toggle',
    chatMessageContainer: '.js-chat-message-container',
    chatMessage: '.chat__message',
    chatClientOptions: '.chat__option-button',
    chatClientOptionsContainer: '.chat__customer-options',
    chatSubmitButton: '.chat__submit-button',
    chatButton: '.chat__button',
    chatMinus: '.js-chat-minus',
    chatSoundAudio: '.chat__sound',
    chatWindow: '.js-chat-window',
    decreaseChatFontSize: '#js-decrease-font-size',
    enableChatSounds: '#js-enable-sounds',
    increaseChatFontSize: '#js-increase-font-size',
    muteChatSounds: '#js-mute-sounds',
    ericaHeaders: '.sticky-header__erica-container'
  },
  CSS_MODIFIERS: {
    chatFreezeScroll: 'chat__freeze-scroll',
    chatOpen: 'chat--open',
    disabled: 'disabled',
    fontSize16: 'chat__font-16',
    fontSize20: 'chat__font-20',
    hide: 'hide',
    hidden: 'hidden',
    menuButtonClicked: 'menu__button-clicked'
  },
  ANIMATION_END_EVENTS: ['animationend', 'webkitAnimationEnd', 'oAnimationEnd'],
  ANIMATION_CLASSNAMES: {
    fadeIn: 'fadeIn',
    fadeOut: 'fadeOut',
    slideInDown: 'slideInDown',
    slideInRight: 'slideInRight',
    slideInUp: 'slideInUp',
    slideOutDown: 'slideOutDown',
    slideOutRight: 'slideOutRight',
    slideOutUp: 'slideOutUp'
  },
  END_OF_FLOW_CLASSNAMES: {
    header: 'chat__end-of-flow-header',
    body: 'chat__end-of-flow-body',
    list: 'chat__end-of-flow-list',
    footer: 'chat__end-of-flow-footer',
    cta: 'chat__end-of-flow-cta',
    disclosure: 'chat__end-of-flow-disclosure'
  },
  TEMPLATES: {
    messageErica: '<div class="chat__message chat__message-of-erica slideInLeft">{message}</div>',
    messageEricaWithIcon: '<div class="chat__message chat__message-of-erica chat__message-of-erica-with-icon slideInLeft">{message}</div>',
    messageClient: '<div class="chat__message chat__customer-options slideInRight">{message}</div>',
    clientOptionMultiple: '<div class="chat__checkbox-container"><label><input data-option=\'{optionObj}\' type="checkbox" name="multiSelection" value="{optionId}" id="{optionId}" class="chat__option-checkbox"><span>{option}</span></label></div>',
    clientSubmitBtn: '<button type="submit" class="chat__submit-button">OK</button>',
    clientOption: '<button data-option=\'{optionObj}\' class="chat__option-button">{option}</button>',
    clientSelection: '<div class="chat__message chat__customer-selection">{message}</div>',
    endOfFlow: '<div class="chat__end-of-flow">{message}</div>',
    endOfFlowIcon: '<img alt="" src="{iconSrc}">',
    endOfFlowRow: '<div class="chat__end-of-flow-row {class}">{iconPlaceholder}<span>{text}<span/></div>'
  },
  MESSAGE_TYPE_ERICA: 'erica',
  MESSAGE_TYPE_CLIENT: 'client',
  MESSAGE_TYPE_CLIENT_SELECTION: 'selection',
  MESSAGE_TYPE_END_OF_FLOW: 'end',
  ERICA_TYPING_DURATION: '2000',
  END_CHAT_ON_CLOSE: true,
  ERICA_SESSION_STORAGE: 'ericaSessionStorage',
  ERICA_TYPING_ANIMATION: '<div class="la-ball-pulse-sync la-dark la-sm"><div></div><div></div><div></div></div>',
  LARGE_FONT: '20px',
  SMALL_FONT: '16px',
  ARIA_HIDDEN: 'aria-hidden'
};

/* eslint-disable no-underscore-dangle */
/* eslint-disable no-console */

/* global constants */

const {
  SELECTORS: SELECTORS$2,
  CSS_MODIFIERS: CSS_MODIFIERS$1,
  ANIMATION_CLASSNAMES
} = constants;
const functions = {
  /**
   * Plays the messaging sound
   *
   * @param {HTMLAudioElement} el Audio
   * @returns {void}
   */
  playSound: el => {
    try {
      // eslint-disable-next-line no-param-reassign
      el.currentTime = 0;
      el.play();
    } catch (e) {
      console.error(e);
    }
  },
  /**
   * Change font size
   * @param {HTMLElement|Array<HTMLElement>} elements we want to assign new font to
   * @param {string} from font class name
   * @param {string} to font class name
   * @returns {undefined}
   */
  changeFontSize(elements, from, to) {
    if (Array.isArray(elements)) {
      elements.forEach(element => {
        element.classList.remove(from);
        element.classList.add(to);
      });
    } else {
      elements.classList.remove(from);
      elements.classList.add(to);
    }
  },
  /**
   * Add hidden class when animation fade/slide out completes to hide content from DOM.
   *
   * @param {HTMLElement} e animationend event
   * @returns {void}
   */
  hideOnAnimOut: e => {
    if (e.target.classList.contains(ANIMATION_CLASSNAMES.fadeOut) || e.target.classList.contains(ANIMATION_CLASSNAMES.slideOutDown) || e.target.classList.contains(ANIMATION_CLASSNAMES.slideOutUp) || e.target.classList.contains(ANIMATION_CLASSNAMES.slideOutRight) || e.target.classList.contains(ANIMATION_CLASSNAMES.slideOutLeft)) {
      e.target.classList.add(CSS_MODIFIERS$1.hidden);
    }
  },
  /**
   * Show the loading animation element
   *
   * @returns {undefined}
   */
  showLoadingAnimation: () => {
    const loadingEl = document.querySelector(SELECTORS$2.chatLoadingAnimation);
    if (loadingEl && loadingEl.classList.contains(CSS_MODIFIERS$1.hide)) {
      loadingEl.classList.remove(CSS_MODIFIERS$1.hide);
    }
  },
  /**
   * Show the loading animation element
   *
   * @returns {undefined}
   */
  hideLoadingAnimation: () => {
    const loadingEl = document.querySelector(SELECTORS$2.chatLoadingAnimation);
    if (loadingEl && !loadingEl.classList.contains(CSS_MODIFIERS$1.hide)) {
      loadingEl.classList.add(CSS_MODIFIERS$1.hide);
    }
  },
  /**
   * Handles animation for showing an element
   *
   * @param {HTMLElement} el - element to show
   * @returns {void}
   */
  animateShowEl: el => {
    el.classList.remove(CSS_MODIFIERS$1.hidden);
    el.classList.remove(ANIMATION_CLASSNAMES.fadeOut);
    el.classList.add(ANIMATION_CLASSNAMES.fadeIn);
  },
  /**
   * Handles animation for hiding an element
   *
   * @param {HTMLElement} el - element to hide
   * @returns {void}
   */
  animateHideEl: el => {
    el.classList.remove(ANIMATION_CLASSNAMES.fadeIn);
    el.classList.add(ANIMATION_CLASSNAMES.fadeOut);
  },
  /**
   * Auto links URLs
   *
   * @param {String} str markup
   * @returns {String} autolinked markup
   */
  autoLink: str => {
    const regExp = /(?![^<]*>|[^<>]*<\/)((https?:)\/\/[a-z0-9&#=./\-?_:~%]+)/gi;
    const anchor = '<a href="$1" target="_blank" rel="noreferrer noopener">$1</a>';
    return str.replace(regExp, anchor);
  },
  /**
   * JCR data from the data-jcr attribute.
   *
   * @returns {Object} Filtered JCR content based on clientSideVisibleJcrKeys.
   */
  getJcrData: () => JSON.parse(document.querySelector(SELECTORS$2.chat).dataset.jcr),
  removeTypingBubbles: () => {
    const messageContainer = document.querySelector('.chat__message-container');
    if (messageContainer) messageContainer.removeChild(messageContainer.lastElementChild);
  }
};

/* eslint-disable no-underscore-dangle */
/* global constants functions */

/* eslint-disable import/prefer-default-export */

// const {
//   pageTitleNotifier,
// } = falconDependencyManager.getDependencies();

const {
  SELECTORS: SELECTORS$1,
  TEMPLATES,
  MESSAGE_TYPE_ERICA,
  MESSAGE_TYPE_CLIENT,
  MESSAGE_TYPE_CLIENT_SELECTION: MESSAGE_TYPE_CLIENT_SELECTION$1,
  MESSAGE_TYPE_END_OF_FLOW,
  END_OF_FLOW_CLASSNAMES,
  LARGE_FONT: LARGE_FONT$1
} = constants;
const {
  playSound,
  autoLink
} = functions;

/**
 * Class for housing all of the logic related to messaging in the chat
 *
 * @class Message
 */
class Message {
  /**
   * Initialize the module
   *
   * @param {EricaChatModule} ericaChatModule - instance of caller module
   * @returns {void}
   */
  init(ericaChatModule) {
    this.ericaChatModule = ericaChatModule;
    this.target = ericaChatModule.settings.target;
    this.currentMessage = null;
    pageTitleNotifier.init();
  }

  /**
   * Dispatch a message
   *
   * @memberof EricaChatModule
   * @param {Object} msg all messages of a single question
   * @returns {void}
   */
  dispatchMessage(msg) {
    this.currentMessage = msg;
    if (msg.type === 'erica') {
      this.newEricaMessage(msg);
    } else if (msg.type === 'client') {
      this.newClientOptions(msg);
    } else if (msg.type === 'endOfFlow') {
      this.endOfFlow(msg);
    }
  }

  /**
   * Appends the message into the chat message window.
   * Used to populate historical messages.
   *
   * @param {String} message message string
   * @param {String} type user type
   * @returns {void}
   */
  appendMessage(...args) {
    const messageEl = this.renderMessage(...args);
    this.insertMessage(messageEl);
    const [message, type] = args;
    if (!message) return;

    // Remove previous erica icon
    if (type === MESSAGE_TYPE_ERICA) {
      this.removePreviousEricaIcon();
    }
    if ([MESSAGE_TYPE_ERICA, MESSAGE_TYPE_CLIENT_SELECTION$1].indexOf(type) > -1) {
      this.ericaChatModule.scrollMessageIntoView();
    }
  }

  /**
   * Generic receptor for all messages to be displayed in the chat window.
   *
   * @param {*} message - message to be added to the chat window.
   * @returns {void}
   */
  insertMessage(message) {
    const messageContainer = this.target.querySelector(SELECTORS$1.chatMessageContainer);
    this.target.querySelector(SELECTORS$1.chatWindow).classList.remove('hide');
    messageContainer.insertAdjacentHTML('beforeend', message);
    if (message.includes('la-ball-pulse-sync')) {
      messageContainer.lastChild.style.padding = '9px 16px 16px';
    }
  }

  /**
   * Render message string.
   *
   * @param {String} message message string
   * @param {String} type template type to render
   * @returns {String} rendered message
   */
  renderMessage(message, type) {
    const templateTypes = {};
    templateTypes[MESSAGE_TYPE_ERICA] = 'messageEricaWithIcon';
    templateTypes[MESSAGE_TYPE_CLIENT] = 'messageClient';
    templateTypes[MESSAGE_TYPE_CLIENT_SELECTION$1] = 'clientSelection';
    templateTypes[MESSAGE_TYPE_END_OF_FLOW] = 'endOfFlow';
    if (!templateTypes[type]) throw new Error(`Unable to render message, unsupported type '${type}'.`);
    const templatedMessage = TEMPLATES[templateTypes[type]].replace('{message}', autoLink(message));
    return templatedMessage;
  }

  /**
   * Appends new Erica message.
   *
   * @param {String} msg agent message string
   * @returns {void}
   */
  newEricaMessage(msg) {
    const messageType = MESSAGE_TYPE_ERICA;
    let renderedMessage = msg.text;
    let previousQuestionSelectionIndex = 0;
    if (msg.insertPreviousQuestionSelection) {
      if (typeof msg.previousQuestionSelectionIndex === 'number') {
        previousQuestionSelectionIndex = msg.previousQuestionSelectionIndex;
      } else {
        previousQuestionSelectionIndex = msg.question - 1;
      }
      const prevQuestionSelection = this.ericaChatModule.clientSelections[previousQuestionSelectionIndex].altText;
      renderedMessage = renderedMessage.replace('{previousQuestionSelection}', prevQuestionSelection);
    }
    this.appendMessage(renderedMessage, messageType, msg.hasBofaIcon);
    if (msg.text !== '...') {
      this.ericaChatModule.messagesArray.push(msg);
    }
    if (msg.insertPreviousQuestionSelection) {
      const lastArrayTarget = this.ericaChatModule.messagesArray.length - 1;
      const lastObject = this.ericaChatModule.messagesArray[lastArrayTarget];
      lastObject.text = renderedMessage;
    }
    this.ericaChatModule._ericaChatStore.messagesArray = this.ericaChatModule.messagesArray;
    this.ericaChatModule.ericaChatStore = this.ericaChatModule._ericaChatStore;
    this.ericaChatModule.scrollMessageIntoView();
    playSound(this.target.querySelector(SELECTORS$1.chatSoundAudio));
  }

  /**
   * Appends client options buttons
   *
   * @param {Object} msg options for client to choose
   * @returns {void}
   */
  newClientOptions(msg) {
    const {
      options,
      multipleSelection
    } = msg;
    const renderedOptions = this.renderOptions(options, multipleSelection);
    this.appendMessage(renderedOptions, MESSAGE_TYPE_CLIENT);
    const clientOptions = this.target.querySelectorAll(SELECTORS$1.chatClientOptions);
    if (multipleSelection) {
      const chatSubmitButton = this.target.querySelector(SELECTORS$1.chatSubmitButton);
      chatSubmitButton.addEventListener('click', e => {
        e.preventDefault();
        this.handleSelectionSubmit(msg.question);
      });
    } else {
      [...clientOptions].forEach(option => {
        option.addEventListener('click', e => {
          this.handleSelectionSubmit(msg.question, e.currentTarget.dataset.option);
        });
        if (this.ericaChatModule._ericaChatStore.font === true) {
          // eslint-disable-next-line no-param-reassign
          option.style.fontSize = LARGE_FONT$1;
        }
      });
    }
  }

  /**
   * Submits user multi selections
   *
   * @param   {Number}  questionIndex  The index of the current question
   * @param   {Object}  singleSelection  The object of the selected single option
   *
   * @return  {Void} no return
   */
  handleSelectionSubmit(questionIndex, singleSelection = null) {
    let clientSelection;
    let clientSelectionText;
    if (singleSelection) {
      clientSelection = JSON.parse(singleSelection);
      clientSelectionText = clientSelection.text;
    } else {
      const clientSelectionElements = [...this.target.querySelectorAll('input[name="multiSelection"]:checked')];
      const selectedOptions = clientSelectionElements.map(el => JSON.parse(el.dataset.option));
      if (selectedOptions.length > 0) {
        clientSelection = selectedOptions;
        clientSelectionText = clientSelection.map(selection => selection.text).join('<br/>');
      }
    }
    if (clientSelection) {
      const selectionContainer = document.querySelector(`${SELECTORS$1.chatClientOptionsContainer}:last-of-type`);
      this.hideElement(selectionContainer);
      this.ericaChatModule.clientSelections.push(clientSelection);

      // session storage
      this.ericaChatModule.messagesArray.push(clientSelection);
      this.ericaChatModule._ericaChatStore.clientSelections = this.ericaChatModule.clientSelections;
      this.ericaChatModule.ericaChatStore = this.ericaChatModule._ericaChatStore;
      this.appendMessage(clientSelectionText, MESSAGE_TYPE_CLIENT_SELECTION$1);
      if (questionIndex < this.ericaChatModule.allQuestions.length - 1) {
        this.ericaChatModule.iterateMessages(questionIndex + 1);
      }
    }
  }

  /**
   * Render end of flow screen
   *
   * @param {Object} msg msg object
   * @returns {void}
   */
  endOfFlow(msg) {
    this.addLastEricaIcon();
    const {
      list,
      footer,
      cta,
      disclosure
    } = msg;
    const endResponseFromQuestions = [0, 1, 2];
    const selections = this.ericaChatModule.clientSelections;
    let response = '';
    let responseBody = '';
    const q3responseArr = [];
    endResponseFromQuestions.forEach(i => {
      let selectionsArray = [];
      if (!Array.isArray(selections[i])) {
        selectionsArray[0] = selections[i];
      } else {
        selectionsArray = selections[i];
      }
      selectionsArray.forEach(selection => {
        if (!selection.endResponse) {
          q3responseArr.push(selection);
          return;
        }
        const {
          endResponse
        } = selection;
        responseBody += this.renderEndOfFlowRow(endResponse, END_OF_FLOW_CLASSNAMES.body);
      });
    });
    response += responseBody;
    let responseList = '';
    q3responseArr.forEach(item => {
      list.forEach(listItem => {
        if (listItem.name === item.text) {
          responseList += this.renderEndOfFlowRow(listItem.text, END_OF_FLOW_CLASSNAMES.list, listItem.iconSrc);
        }
      });
    });
    response += responseList;
    response += this.renderEndOfFlowRow(footer, END_OF_FLOW_CLASSNAMES.footer);
    response += this.renderEndOfFlowRow(cta.phone, END_OF_FLOW_CLASSNAMES.cta, cta.iconSrc);
    response += this.renderEndOfFlowRow(disclosure.link, END_OF_FLOW_CLASSNAMES.disclosure);
    response += this.renderEndOfFlowRow(disclosure.text, END_OF_FLOW_CLASSNAMES.disclosure);
    this.appendMessage(response, MESSAGE_TYPE_END_OF_FLOW);

    // session storage
    // check if endOfFlow is already stored.
    if (!this.ericaChatModule._ericaChatStore.messagesArray.find(msgEl => msgEl.type === 'endOfFlow')) {
      this.ericaChatModule.messagesArray.push(msg);
      this.ericaChatModule._ericaChatStore.messagesArray = this.ericaChatModule.messagesArray;
      this.ericaChatModule.ericaChatStore = this.ericaChatModule._ericaChatStore;
      this.ericaChatModule.scrollMessageIntoView();
      playSound(this.target.querySelector(SELECTORS$1.chatSoundAudio));
    }
    const disclosureBtn = this.target.querySelector('.chat__view-disclosure-link');
    disclosureBtn.classList.add('hide');
    disclosureBtn.addEventListener('click', () => {
      this.toggleDisclosure();
    });
  }

  /**
   * Returns rendered row
   *
   * @param   {String}  text       the text to be used in the template
   * @param   {String}  className  the class name
   * @param   {String}  iconSrc  the src of the icon
   *
   * @return  {String}             templated row
   */
  renderEndOfFlowRow(text, className, iconSrc = null) {
    const rowTemplate = TEMPLATES.endOfFlowRow;
    let iconDiv = '';
    if (iconSrc) {
      iconDiv = TEMPLATES.endOfFlowIcon.replace('{iconSrc}', iconSrc);
    }
    return rowTemplate.replace('{text}', text).replace('{class}', className).replace('{iconPlaceholder}', iconDiv);
  }

  /**
   * Renders client options
   *
   * @param {Object} options options for client to choose
   * @param {Boolean} multipleSelection true if multiple options is allowed
   * @returns {void}
   */
  renderOptions(options, multipleSelection) {
    let customOptions = null;
    if (this.currentMessage.question > 0) {
      customOptions = this.ericaChatModule.clientSelections[this.currentMessage.question - 1].nextQuestionCustomOptions;
    }
    let filteredOptions = options;
    if (customOptions) {
      filteredOptions = options.filter((option, i) => {
        if (customOptions.includes(i)) return true;
        return false;
      });
    }
    let templatedOption = '';
    let template = '';
    let submitBtn = '';
    if (multipleSelection) {
      template = TEMPLATES.clientOptionMultiple;
      submitBtn = TEMPLATES.clientSubmitBtn;
    } else {
      template = TEMPLATES.clientOption;
    }
    filteredOptions.forEach(option => {
      if (this.currentMessage.question === 0 || customOptions || !customOptions && option.showByDefault) {
        templatedOption += template.replace('{option}', option.text).replace('{optionObj}', JSON.stringify(option));
        if (multipleSelection) {
          const regex = /{optionId}/g;
          templatedOption = templatedOption.replace(regex, option.id);
        }
      }
    });
    templatedOption += submitBtn;
    if (multipleSelection) templatedOption = `<form>${templatedOption}</form>`;
    return templatedOption;
  }

  /**
   * Deletes all messages already in erica chat.
   *
   * @return {void}
   */
  clearMessages() {
    const messages = [...this.target.querySelectorAll(`${SELECTORS$1.chatMessage}, .chat__end-of-flow`)];
    messages.forEach(msg => msg.remove());
  }

  /**
   * Removes previous erica icon.
   *
   * @return {void}
   */
  removePreviousEricaIcon() {
    const lastEricaMessage = this.target.querySelector('[class~="chat__message-of-erica"]:last-of-type');
    if (lastEricaMessage) {
      const prevSibling = lastEricaMessage.previousElementSibling;
      if (prevSibling && prevSibling.classList.contains('chat__message-of-erica-with-icon')) {
        prevSibling.classList.remove('chat__message-of-erica-with-icon');
      }
    }
  }

  /**
   * Adds last erica icon.
   *
   * @return {void}
   */
  addLastEricaIcon() {
    const lastEricaMessage = this.target.querySelector('[class~="chat__message-of-erica"]:last-of-type');
    if (lastEricaMessage) {
      lastEricaMessage.classList.add('chat__message-of-erica-with-icon');
    }
  }

  /**
   * Hides element visually and for ADA screen reader (aria)
   *
   * @param {el} el element to be hidden
   * @return {void}
   */
  hideElement(el) {
    el.classList.add('hide');
    el.setAttribute('aria-hidden', 'true');
  }

  /**
   * Toggles disclosure text
   *
   * @return  {[type]}  [return description]
   */
  toggleDisclosure() {
    const disclosureContainer = this.target.querySelector('.chat__disclosure-container');
    if (disclosureContainer.classList.contains('hide')) {
      disclosureContainer.classList.remove('hide');
    } else {
      disclosureContainer.classList.add('hide');
    }
  }
}
const message = new Message();

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"chat js-chat hidden\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"questions") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":1,"column":43},"end":{"line":1,"column":61}}}))
    + "\">\n  <div class=\"header--top js-chat-header\" style=\"background-image: url("
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"images") : depth0)) != null ? lookupProperty(stack1,"chatHeaderRedImage") : stack1)) != null ? lookupProperty(stack1,"src") : stack1), depth0)) != null ? stack1 : "")
    + ");\">\n    <button class=\"menu__button js-chat-menu-toggle\" aria-expanded=\"false\"\n      aria-controls=\"chatMenuListItems\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"copy") : depth0)) != null ? lookupProperty(stack1,"menu") : stack1), depth0)) != null ? stack1 : "")
    + "</button>\n    <div class=\"chat__menu js-chat-menu-list-items hide\" id=\"chatMenuListItems\">\n      <a href=\"javascript:void(0);\" class=\"chat__menu-actions chat__menu-increase-font-size-action\" id=\"js-increase-font-size\">\n        <span class=\"chat__menu-icon chat--icon-font-increase\"\n          style=\"background-image: url("
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"images") : depth0)) != null ? lookupProperty(stack1,"iconFontIncrease") : stack1)) != null ? lookupProperty(stack1,"src") : stack1), depth0))
    + ");\"></span>\n        <span class=\"chat__menu-text\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"copy") : depth0)) != null ? lookupProperty(stack1,"increaseFontSize") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\n      </a>\n      <a href=\"javascript:void(0);\" class=\"chat__menu-actions chat__menu-decrease-font-size-action hide\" id=\"js-decrease-font-size\">\n        <span class=\"chat__menu-icon chat--icon-font-decrease\"\n          style=\"background-image: url("
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"images") : depth0)) != null ? lookupProperty(stack1,"iconFontDecrease") : stack1)) != null ? lookupProperty(stack1,"src") : stack1), depth0))
    + ");\"></span>\n        <span class=\"chat__menu-text\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"copy") : depth0)) != null ? lookupProperty(stack1,"decreaseFontSize") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\n      </a>\n      <a href=\"javascript:void(0);\" class=\"chat__menu-actions chat__menu-mute-action\" id=\"js-mute-sounds\">\n        <span class=\"chat__menu-icon chat--icon-mute\" style=\"background-image: url("
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"images") : depth0)) != null ? lookupProperty(stack1,"iconMute") : stack1)) != null ? lookupProperty(stack1,"src") : stack1), depth0))
    + ");\"></span>\n        <span class=\"chat__menu-text\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"copy") : depth0)) != null ? lookupProperty(stack1,"muteSounds") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\n      </a>\n      <a href=\"javascript:void(0);\" class=\"chat__menu-actions chat__menu-unmute-action hide\" id=\"js-enable-sounds\">\n        <span class=\"chat__menu-icon chat--icon-unmute\"\n          style=\"background-image: url("
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"images") : depth0)) != null ? lookupProperty(stack1,"iconUnmute") : stack1)) != null ? lookupProperty(stack1,"src") : stack1), depth0))
    + ");\"></span>\n        <span class=\"chat__menu-text\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"copy") : depth0)) != null ? lookupProperty(stack1,"enableSounds") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\n      </a>\n    </div>\n    <div class=\"header\">\n      <div class=\"header__title\">\n        <span class=\"header__title-chat\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"copy") : depth0)) != null ? lookupProperty(stack1,"chatHeaderTitle") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\n      </div>\n    </div>\n    <button class=\"chat__minimize js-chat-minus\">\n      <span class=\"ada-hidden\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"copy") : depth0)) != null ? lookupProperty(stack1,"minimizeChatAda") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\n      <div class=\"chat__minimize--icon\" aria-hidden=\"true\"></div>\n    </button>\n    <button class=\"chat__close js-chat-disconnect\">\n      <span class=\"ada-hidden\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"copy") : depth0)) != null ? lookupProperty(stack1,"closeChatAda") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\n      <div class=\"chat__close--icon\" aria-hidden=\"true\"></div>\n    </button>\n  </div>\n  <div class=\"chat__window js-chat-window hide\">\n    <div class=\"chat__message-container chat__font-16 js-chat-message-container\" aria-atomic=\"false\" aria-live=\"off\">\n      <div class=\"chat__disclosures\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"copy") : depth0)) != null ? lookupProperty(stack1,"chatMonitoredInfoText") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\n    </div>\n  </div>\n  <div class=\"chat__loading-pane\">\n    <div class=\"la-ball-beat\">\n      <div></div>\n      <div></div>\n      <div></div>\n    </div>\n  </div>\n</div>\n<audio class=\"chat__sound hide\">\n  <source src=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"images") : depth0)) != null ? lookupProperty(stack1,"defaultSoundFile") : stack1)) != null ? lookupProperty(stack1,"src") : stack1), depth0))
    + "\" type=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"images") : depth0)) != null ? lookupProperty(stack1,"defaultSoundFile") : stack1)) != null ? lookupProperty(stack1,"type") : stack1), depth0))
    + "\">\n</audio>\n<style type=\"text/css\">\n  .erica-chat-module .chat__message-of-erica-with-icon::before {\n    background-image: url("
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"images") : depth0)) != null ? lookupProperty(stack1,"ericaLogoSmall") : stack1)) != null ? lookupProperty(stack1,"src") : stack1), depth0)) != null ? stack1 : "")
    + ");\n  }\n\n  .chat__erica-typing,\n  .chat__loader {\n    background-image: url("
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"images") : depth0)) != null ? lookupProperty(stack1,"agentTyping") : stack1)) != null ? lookupProperty(stack1,"src") : stack1), depth0)) != null ? stack1 : "")
    + ");\n  }\n</style>\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.falcon.modules/erica-chat-module",
  "version": "1.0.0",
  "id": "ericaChatModule",
  "containerID": "falconEricaChatModule",
  "moduleName": "falcon-erica-chat-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "erica-chat-module",
  "data": {
    "init": "EricaChatModule",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        json
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    json
  },
  "dependencies": {
    "@sparta.community.utilities/draggable-utility": "^1.0.0",
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.global.helpers/select-helper": "^1.0.0",
    "@sparta.global.utilities/focus-trap-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/page-title-notifier": "^1.0.0",
    "@sparta.global.utilities/sparta-store-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/handlebars": "^4.7.7",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/* eslint-disable new-cap */
/* eslint-disable no-console */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */

/* global constants functions message */

/* eslint-disable no-param-reassign */

const {
  ANIMATION_END_EVENTS,
  SELECTORS,
  CSS_MODIFIERS,
  ERICA_TYPING_DURATION,
  END_CHAT_ON_CLOSE,
  MESSAGE_TYPE_CLIENT_SELECTION,
  ERICA_SESSION_STORAGE,
  ERICA_TYPING_ANIMATION,
  LARGE_FONT,
  SMALL_FONT,
  ARIA_HIDDEN
} = constants;
const {
  animateHideEl,
  animateShowEl,
  getJcrData,
  hideOnAnimOut
} = functions;
const focusTrap = focusTrapUtility({});
/**
 * Controls logic for the Erica chat.
 *
 * @export
 * @class EricaChatModule
 * @extends {Module}
 */
class EricaChatModule extends Module {
  /**
   * Setter for ericaChatStore
   *
   * @param {Object} data store object
   * @returns {void}
   */
  set ericaChatStore(data) {
    this.Store.updatePersisted(ERICA_SESSION_STORAGE, data, 'sessionStorage');
  }

  /**
   * Getter for ericaChatStore
   * @returns {Object} the store
   */
  get ericaChatStore() {
    return this.Store.getPersisted(ERICA_SESSION_STORAGE, 'sessionStorage');
  }

  /**
   * Setter for open
   *
   * @param {Boolean} open state
   * @returns {void}
   */
  set open(open) {
    this._open = open;
    this._ericaChatStore = this.ericaChatStore;
    this._ericaChatStore.open = this._open;
    this.ericaChatStore = this._ericaChatStore;
  }

  /**
   * Getter for open
   *
   * @readonly
   * @returns {Boolean} open
   */
  get open() {
    return this._open;
  }

  /**
   * Setter for x of Erica chat.
   *
   * @param {Number} x position
   * @returns {void}
   */
  set x(x) {
    this._x = x;
    this._ericaChatStore = this.ericaChatStore;
    this._ericaChatStore.x = this._x;
    this.ericaChatStore = this._ericaChatStore;
  }

  /**
   * Getter for x
   *
   * @readonly
   */
  get x() {
    return this._x;
  }

  /**
   * Setter for y of Erica chat.
   *
   * @param {Number} y position
   * @returns {void}
   */
  set y(y) {
    this._y = y;
    this._ericaChatStore = this.ericaChatStore;
    this._ericaChatStore.y = this._y;
    this.ericaChatStore = this._ericaChatStore;
  }

  /**
   * Getter for y
   *
   * @readonly
   */
  get y() {
    return this._y;
  }

  /**
   * Sets font increased.
   *
   * @param {Boolean} font option
   * @returns {void}
   */
  set font(font) {
    this._font = font;
    this._ericaChatStore = this.ericaChatStore;
    this._ericaChatStore.font = this._font;
    this.ericaChatStore = this._ericaChatStore;
  }

  /**
   * Gets font increased.
   *
   * @readonly
   * @returns {Boolean} font option
   */
  get font() {
    return this._font;
  }

  /**
   * Sets sound.
   *
   * @param {Boolean} sound option
   * @returns {void}
   */
  set sound(sound) {
    this._sound = sound;
    this._ericaChatStore = this.ericaChatStore;
    this._ericaChatStore.sound = this._sound;
    this.ericaChatStore = this._ericaChatStore;
  }

  /**
   * Gets sound.
   *
   * @readonly
   * @returns {Boolean} sound
   */
  get sound() {
    return this._sound;
  }

  /**
   * Sets messagesArray.
   *
   * @param {Object} messagesArray array
   * @returns {void}
   */
  set messagesArray(messagesArray) {
    this._messagesArray = messagesArray;
    if (this._ericaChatStore !== undefined) {
      this._ericaChatStore = this.ericaChatStore;
      this._ericaChatStore.messagesArray = this._messagesArray;
      this.ericaChatStore = this._ericaChatStore;
    }
  }

  /**
   * Gets messagesArray.
   *
   * @readonly
   * @returns {Object} messagesArray array
   */
  get messagesArray() {
    return this._messagesArray;
  }

  /**
   * Sets clientSelections.
   *
   * @param {Object} clientSelections array
   * @returns {void}
   */
  set clientSelections(clientSelections) {
    this._clientSelections = clientSelections;
    if (this._ericaChatStore !== undefined) {
      this._ericaChatStore = this.ericaChatStore;
      this._ericaChatStore.clientSelections = this._clientSelections;
      this.ericaChatStore = this._ericaChatStore;
    }
  }

  /**
   * Gets clientsSelection.
   *
   * @readonly
   * @returns {Object} clientSelections array
   */
  get clientSelections() {
    return this._clientSelections;
  }

  /**
   * Creates an instance of EricaChatModule.
   *
   * @param {*} params inherited params
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.smallMq = window.matchMedia('(max-width: 767px)');
    const {
      target
    } = this.settings;
    this.target = target;
    this.initAllQuestions();
    this.ericaInitiated = false;
    this.chatEl = target.querySelector(SELECTORS.chat);
    this.chatButtonEls = [...document.querySelectorAll(SELECTORS.chatButton)];
    this.ericaHeaders = [...document.querySelectorAll(SELECTORS.ericaHeaders)];
    this.chatCloseButtonEl = target.querySelector(SELECTORS.chatCloseButton);
    this.chatMinimizeButtonEl = target.querySelector(SELECTORS.chatMinimizeButton);
    this.chatMenuToggleEl = target.querySelector(SELECTORS.chatMenuToggle);
    this.chatMenuItemsEl = target.querySelector(SELECTORS.chatMenuListItems);
    this.decreaseFontSizeEl = target.querySelector(SELECTORS.decreaseChatFontSize);
    this.increaseFontSizeEl = target.querySelector(SELECTORS.increaseChatFontSize);
    this.muteSoundsEl = target.querySelector(SELECTORS.muteChatSounds);
    this.enableSoundsEl = target.querySelector(SELECTORS.enableChatSounds);
    this.chatSoundAudioEl = target.querySelector(SELECTORS.chatSoundAudio);
    this.chatHeaderTitleEl = target.querySelector(SELECTORS.chatHeaderTitle);
    this.chatContainerEl = target.querySelector(SELECTORS.chatMessageContainer);
    if (this.ericaChatStore !== undefined) {
      this._ericaChatStore = this.ericaChatStore;
    }
    if (!this._ericaChatStore) {
      this.messagesArray = [];
      this.clientSelections = [];
    } else {
      this.messagesArray = this._ericaChatStore.messagesArray;
      this.clientSelections = this._ericaChatStore.clientSelections;
    }
  }

  /**
   * Called when this module is bootstrapped by the client.
   *
   * @returns {void}
   */
  init() {
    this.target.classList.add('loaded');
    pageTitleNotifier.init();
    message.init(this);
    this.bindListeners();
    if (this.ericaChatStore === undefined) {
      this.initSessionStore();
    } else {
      this.chatStorageInit();
    }
  }

  /**
   * Initiates Erica chat
   *
   * @memberof EricaChatModule
   * @returns {void}
   */
  ericaChatInit() {
    this.ericaInitiated = true;
    if (this.ericaChatStore && this.ericaChatStore.messagesArray.length > 0) {
      this.iterateStoreMessages();
    } else {
      this.iterateMessages();
    }
  }

  /**
   * Refreshes allQuestions object by setting initial values
   * because allQuestions object is updated by clients selections
   * @returns {void}
   */
  initAllQuestions() {
    const allQuestionsObj = getJcrData();
    delete allQuestionsObj.jcr;
    this.allQuestions = Object.values(allQuestionsObj);
  }

  /**
   * Delays message for erica typing bubbles.
   *
   * @return {Promise} setTimeout
   */
  ericaTyping() {
    const delay = ERICA_TYPING_DURATION;
    message.appendMessage(`${ERICA_TYPING_ANIMATION}`, 'erica');
    return new Promise(resolve => {
      setTimeout(resolve, delay);
    });
  }

  /**
   * Iterates through messages of a single question
   *
   * @memberof EricaChatModule
   * @param {Number} questionIndex array index of the question.
   * @param {Number} messageIndex array index of the message.
   * @returns {void}
   */
  async iterateMessages(questionIndex = 0, messageIndex = 0) {
    const allMessages = this.allQuestions[questionIndex];
    const msgObj = allMessages[messageIndex];
    msgObj.question = questionIndex;

    // check for last erica message to add icon
    const nextMsgObj = allMessages[messageIndex + 1];
    if (messageIndex < allMessages.length - 1 && nextMsgObj.type === 'client') {
      msgObj.hasBofaIcon = true;
    }
    if (msgObj.type !== 'client') {
      await this.ericaTyping();
      functions.removeTypingBubbles();
    }

    // if user closes chat during delay
    if (this.open) {
      message.dispatchMessage(msgObj);
    } else {
      return;
    }
    if (messageIndex < allMessages.length - 1) {
      this.iterateMessages(questionIndex, messageIndex + 1);
    }
  }

  /**
   * Opens Erica chat when one of Erica button is clicked.
   *
   * @memberof EricaChatModule
   * @param {Element} chatButton the button clicked to initiate erica chat
   * @returns {void}
   */
  openChatEvent() {
    // Check if it's not already open
    if (this.chatEl.classList.contains(CSS_MODIFIERS.chatOpen)) return;
    this.openChat();
    this.setChatPosition();
    this.setChatFocus();
  }

  /**
   * Set focus on chat.
   *
   * @return {void}
   */
  setChatFocus() {
    focusTrap.setContainer(this.chatEl).attachTrap();
    this.chatCloseButtonEl.focus();
  }

  /**
   * Remove focus from chat and focus on the chat button.
   *
   * @param {domNode} chatButton chat button
   * @return {void}
   */
  removeChatFocus() {
    focusTrap.removeTrap();
    this.ericaHeaders.forEach(element => {
      if (element.style.opacity !== '') {
        const visibleButton = element.childNodes[1].firstElementChild;
        visibleButton.focus();
      }
    });
  }

  /**
   * Open chat.
   *
   * @return {void}
   */
  openChat() {
    this.chatEl.classList.add(CSS_MODIFIERS.chatOpen);
    this.open = true;
    animateShowEl(this.chatEl);
    this.viewportChangeSmall();
    if (!this.ericaInitiated) {
      this.ericaChatInit();
    }
    if (this._ericaChatStore.font === null || this._ericaChatStore.font === undefined) {
      this.decreaseFontSize();
    }
    this.addOrRemoveAriaHiddenMobile();
  }

  /**
   * Sets chat position.
   *
   * @return {void}
   */
  setChatPosition() {
    if (this.Draggable) {
      this.Draggable.removeEvents();
      delete this.Draggable;
    }
    const onDragEnd = (element, x, y) => {
      this.x = x;
      this.y = y;
    };
    const onSizeChange = () => {
      if (!this.open) return;
      const {
        innerWidth,
        innerHeight
      } = window;
      const {
        offsetWidth,
        offsetHeight
      } = this.chatEl;
      this.Draggable.setOption('limit', this.getLimit(innerWidth, innerHeight, offsetWidth, offsetHeight));
    };
    const chatHeader = this.target.querySelector(SELECTORS.chatHeader);
    const {
      innerWidth,
      innerHeight
    } = window;
    const {
      offsetWidth,
      offsetHeight
    } = this.chatEl;
    const options = {
      limit: this.getLimit(innerWidth, innerHeight, offsetWidth, offsetHeight),
      handle: chatHeader,
      isSetDimensions: false,
      disableOnSmall: true,
      disabledPosition: [0, 0],
      onDragEnd,
      onSizeChange
    };
    if (this._ericaChatStore.x !== null || this._ericaChatStore.y !== null) {
      Object.assign(options, {
        position: {
          left: this._ericaChatStore.x,
          top: this._ericaChatStore.y
        }
      });
    } else if (this.x === null && this.y === null) {
      const {
        x,
        y
      } = this.getDefaultPosition();
      Object.assign(options, {
        position: {
          left: x,
          top: y
        }
      });
    } else if (this.x === undefined && this.y === undefined) {
      const {
        x,
        y
      } = this.getDefaultPosition();
      Object.assign(options, {
        position: {
          left: x,
          top: y
        }
      });
    } else {
      Object.assign(options, {
        position: {
          left: this.x,
          top: this.y
        }
      });
    }
    this.Draggable = new draggableUtility(this.chatEl, options, chatHeader);
  }

  /**
   * Gets the default position x and y for erica chat module.
   * Will open in default position if closed and reopened when resizing.
   *
   * @returns {Object} x, y coordinates
   */
  getDefaultPosition() {
    const {
      innerWidth,
      innerHeight
    } = window;
    const {
      offsetWidth,
      offsetHeight
    } = this.chatEl;

    // Bottom right
    return {
      x: innerWidth - offsetWidth - 40,
      y: innerHeight - offsetHeight - 30
    };
  }

  /**
   * Get x and y limit for the chat positioning.
   *
   * @param {string} innerWidth - window innerWidth
   * @param {string} innerHeight - window innerHeight
   * @param {string} offsetWidth - window offsetWidth
   * @param {string} offsetHeight - window offsetHeight
   * @return {{x: number[], y: number[]}} x and y limit
   */
  getLimit(innerWidth, innerHeight, offsetWidth, offsetHeight) {
    return {
      x: [0, innerWidth - offsetWidth],
      y: [0, innerHeight - offsetHeight / 2]
    };
  }

  /**
   * Closes Erica chat.
   *
   * @memberof EricaChatModule
   * @returns {void}
   */
  closeChat() {
    // Check if it's not already closed
    if (!this.chatEl.classList.contains(CSS_MODIFIERS.chatOpen)) return;
    this.chatEl.classList.remove(CSS_MODIFIERS.chatOpen);
    animateHideEl(this.chatEl);
    this.removeChatFocus();
    if (this.Draggable) {
      this.Draggable.removeEvents();
      delete this.Draggable;
    }
    this.open = false;
    this.viewportChangeSmall();
    if (END_CHAT_ON_CLOSE) {
      this.ericaInitiated = false;
      this.clientSelections = [];
      message.clearMessages();
      this.initAllQuestions();
    }
    this.ericaChatStore = {
      messagesArray: [],
      clientSelections: []
    };
    this.x = null;
    this.y = null;
    this.sound = null;
    this.font = null;
    this.messagesArray = [];
    this.clientSelections = [];
    this.addOrRemoveAriaHiddenMobile();
  }

  /**
   * Minimizes Erica chat, maintains state
   *
   * @memberof EricaChatModule
   * @returns {void}
   */
  minimizeChat() {
    if (!this.chatEl.classList.contains(CSS_MODIFIERS.chatOpen)) return;
    this.chatEl.classList.remove(CSS_MODIFIERS.chatOpen);
    animateHideEl(this.chatEl);
    this.removeChatFocus();
    if (this.Draggable) {
      this.Draggable.removeEvents();
      delete this.Draggable;
    }
    this.open = false;
    this.viewportChangeSmall();
    this.addOrRemoveAriaHiddenMobile();
  }

  /**
   * Bind listeners.
   *
   * @returns {void}
   */
  bindListeners() {
    this.bindAnimationListeners();
    this.bindDomEventListeners();
    this.bindViewportChange();
  }

  /**
   * Bind animation listeners.
   *
   * @returns {void}
   */
  bindAnimationListeners() {
    [this.chatEl].forEach(el => {
      ANIMATION_END_EVENTS.forEach(event => {
        el.addEventListener(event, hideOnAnimOut);
      });
    });
  }

  /**
   * Bind DOM event listeners.
   *
   * @returns {void}
   */
  bindDomEventListeners() {
    this.chatCloseButtonEl.addEventListener('click', this.closeChat.bind(this));
    this.chatMinimizeButtonEl.addEventListener('click', this.minimizeChat.bind(this));
    this.increaseFontSizeEl.addEventListener('click', this.increaseFontSize.bind(this));
    this.decreaseFontSizeEl.addEventListener('click', this.decreaseFontSize.bind(this));
    this.muteSoundsEl.addEventListener('click', this.muteSound.bind(this));
    this.enableSoundsEl.addEventListener('click', this.unmuteSound.bind(this));
    window.addEventListener('click', this.closeChatMenuIfClickOutside.bind(this), true);
    window.addEventListener('click', () => focusTrap.removeTrap(), true);

    // ada - when someone exits chat layer and then focuses back (minimize is
    // the first ada tab navigated button), focus will be trapped back on the chat
    this.chatMenuToggleEl.addEventListener('focus', () => focusTrap.setContainer(this.chatEl).attachTrap(), true);
    this.chatButtonEls.forEach(chatButton => {
      chatButton.addEventListener('click', this.openChatEvent.bind(this));
    });
    this.chatMenuToggleEl.addEventListener('click', this.chatMenuToggleEvent.bind(this));

    // Listener for user scrolling in chat.
    this.target.querySelector(SELECTORS.chatWindow).addEventListener('scroll', this.handleChatScroll.bind(this));
  }

  /**
   * Bind viewport change small media query.
   *
   * @returns {void}
   */
  bindViewportChange() {
    this.smallMq.addListener(this.viewportChangeSmall.bind(this));
  }

  /**
   * Viewport change small,
   * freeze the body so the scroller doesn't show in mobile while chat's open.
   *
   * @returns {void}
   */
  viewportChangeSmall() {
    const htmlEl = document.querySelector('html');
    const bodyEl = document.querySelector('body');
    if (!this.chatEl) return;
    if (this.smallMq.matches && this.open) {
      htmlEl.classList.add(CSS_MODIFIERS.chatFreezeScroll);
      bodyEl.classList.add(CSS_MODIFIERS.chatFreezeScroll);
    } else {
      htmlEl.classList.remove(CSS_MODIFIERS.chatFreezeScroll);
      bodyEl.classList.remove(CSS_MODIFIERS.chatFreezeScroll);
    }
  }

  /**
   * Handler for scrolling through chat
   *
   * @returns {void}
   */
  handleChatScroll() {
    const chatWindow = this.target.querySelector(SELECTORS.chatWindow);
    this.scrollTop = chatWindow.scrollTop;
  }

  /**
   * Checks if chat window is at the bottom.
   *
   * @returns {Boolean} true if at bottom, false otherwise
   */
  isChatWindowAtBottom() {
    const chatWindow = this.target.querySelector(SELECTORS.chatWindow);
    return chatWindow.scrollHeight - chatWindow.scrollTop === chatWindow.clientHeight;
  }

  /**
   * Scrolls message into view.
   *
   * @returns {void}
   */
  scrollMessageIntoView() {
    // commenting  the below code for errica scroll issue
    // if (!this.isChatWindowAtBottom()) {      
    //   this.scrollToBottom();            
    // }
  }

  /**
   * Scroll to bottom.
   *
   * @returns {void}
   */
  scrollToBottom() {
    const chatWindow = this.target.querySelector(SELECTORS.chatWindow);
    chatWindow.scrollTop = chatWindow.scrollHeight;

    // Persist the scroll position
    this.scrollTop = chatWindow.scrollTop;
  }

  /**
   * Applys the persisted menu options.
   *
   * @returns {void}
   */
  applyMenuOptions() {
    if (this.font) {
      this.increaseFontSize();
    } else {
      this.decreaseFontSize(); // default decrease
    }

    if (this.sound) {
      this.muteSound();
    } else {
      this.unmuteSound(); // default unmuted
    }
  }

  /**
   * It will increase font size and toggle image & name.
   * Persists the option for navigation.
   *
   * @returns {void}
   */
  increaseFontSize() {
    this.chatClientOptions = [...document.querySelectorAll(SELECTORS.chatClientOptions)];
    this.increaseFontSizeEl.classList.add(CSS_MODIFIERS.hide);
    this.decreaseFontSizeEl.classList.remove(CSS_MODIFIERS.hide);
    this.font = true;
    // changeFontSize();

    this.chatContainerEl.classList.remove(CSS_MODIFIERS.fontSize16);
    this.chatContainerEl.classList.add(CSS_MODIFIERS.fontSize20);
    this.chatClientOptions.forEach(option => {
      option.style.fontSize = LARGE_FONT;
    });
  }

  /**
   * It will decrease font size and toggle image & name.
   * Persists the option for navigation.
   *
   * @returns {void}
   */
  decreaseFontSize() {
    this.chatClientOptions = [...document.querySelectorAll(SELECTORS.chatClientOptions)];
    this.increaseFontSizeEl.classList.remove(CSS_MODIFIERS.hide);
    this.decreaseFontSizeEl.classList.add(CSS_MODIFIERS.hide);
    this.font = false;
    // changeFontSize();

    this.chatContainerEl.classList.remove(CSS_MODIFIERS.fontSize20);
    this.chatContainerEl.classList.add(CSS_MODIFIERS.fontSize16);
    this.chatClientOptions.forEach(option => {
      option.style.fontSize = SMALL_FONT;
    });
  }

  /**
   * Mute suounds.
   * Persists the option for navigation.
   *
   * @returns {void}
   */
  muteSound() {
    this.muteSoundsEl.classList.add(CSS_MODIFIERS.hide);
    this.enableSoundsEl.classList.remove(CSS_MODIFIERS.hide);
    this.chatSoundAudioEl.muted = true;
    this.sound = true;
  }

  /**
   * Unmute suounds.
   * Persists the option for navigation.
   *
   * @returns {void}
   */
  unmuteSound() {
    this.muteSoundsEl.classList.remove(CSS_MODIFIERS.hide);
    this.enableSoundsEl.classList.add(CSS_MODIFIERS.hide);
    this.chatSoundAudioEl.muted = false;
    this.sound = false;
  }

  /**
   * Toggle chat menu.
   *
   * @returns {void}
   */
  chatMenuToggleEvent() {
    this.chatMenuItemsEl.classList.toggle(CSS_MODIFIERS.hide);
    this.chatMenuToggleEl.classList.toggle(CSS_MODIFIERS.menuButtonClicked);
    this.chatMenuToggleEl.setAttribute('aria-expanded', String(!!this.chatMenuToggleEl.getAttribute('aria-expanded')));
  }

  /**
   * Closes the chat menu if clicking outside of the menu
   *
   * @param {Event} event - click event
   * @returns {void}
   */
  closeChatMenuIfClickOutside(event) {
    const {
      target
    } = event;
    const isMenuLinkClicked = this.chatMenuToggleEl.contains(target);
    const isWithinMenuList = this.chatMenuItemsEl.contains(target);
    if (this.chatMenuItemsEl.classList.contains('hide')) return;
    if (isMenuLinkClicked) return;
    if (!isWithinMenuList) this.hideChatMenu();
  }

  /**
   * Hides chat menu.
   *
   * @returns {void}
   */
  hideChatMenu() {
    if (!this.chatMenuItemsEl.classList.contains('hide')) {
      this.chatMenuItemsEl.classList.add(CSS_MODIFIERS.hide);
      this.chatMenuToggleEl.classList.remove(CSS_MODIFIERS.menuButtonClicked);
    }
  }

  /**
   * Checks the session storage for chat.
   *
   * @returns {void}
   */
  initSessionStore() {
    this.Store.persist(ERICA_SESSION_STORAGE, {
      x: this._x,
      y: this._y,
      open: this._open,
      sound: this._sound,
      font: this._font,
      messagesArray: this._messagesArray,
      clientSelections: this._clientSelections
    }, 'sessionStorage');
  }

  /**
   * Init chat with session storage
   *
   * @returns {void}
   */
  chatStorageInit() {
    // persists chat when moving pages or refreshing page

    // is the chat open
    if (this._ericaChatStore.open === true) {
      this.openChatEvent();
    }
    if (this._ericaChatStore.x || this._ericaChatStore.y) {
      this.setChatPosition();
    }

    // is the chat muted
    if (this._ericaChatStore.sound === true) {
      this.muteSound();
    } else {
      this.unmuteSound();
    }

    // is the chat font large/small
    if (this._ericaChatStore.font === true) {
      this.increaseFontSize();
    } else {
      this.decreaseFontSize();
    }
  }

  /**
   * Init chat with session storage
   *
   * @returns {void}
   */
  async iterateStoreMessages() {
    const array = this.ericaChatStore.messagesArray;
    let ericaCount = 0;
    let questionIndex = 0;
    let endOfFlow = false;
    array.forEach(index => {
      if (index.type === 'erica') {
        message.appendMessage(index.text, index.type, index.hasBofaIcon);
        ericaCount++;
      } else if (index.type === 'endOfFlow') {
        message.endOfFlow(index);
        endOfFlow = true;
      } else {
        let clientSelections = '';
        if (Array.isArray(index)) {
          clientSelections = index.map(selection => selection.text).join('<br/>');
        } else {
          clientSelections = index.text;
        }
        message.appendMessage(clientSelections, MESSAGE_TYPE_CLIENT_SELECTION);
        questionIndex++;
        ericaCount = 0;
      }
    });
    if (!endOfFlow) {
      this.iterateMessages(questionIndex, ericaCount);
    }
  }

  /**
   * adds or removes aria-hidden based on chat module and screen size
   *
   * @returns {void}
   */
  addOrRemoveAriaHiddenMobile() {
    const modulesArray = [...document.querySelectorAll("[data-component='module']")];
    if (spartaStoreUtility.getData('currentMQ.mediaQueries.small-only')) {
      modulesArray.forEach(module => {
        if (module.id !== 'ericaChatModule') {
          if (module.hasAttribute(ARIA_HIDDEN)) {
            module.removeAttribute(ARIA_HIDDEN);
          } else {
            module.setAttribute(ARIA_HIDDEN, 'true');
          }
        }
      });
    }
  }
}
registerModuleClass({
  moduleClass: EricaChatModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { EricaChatModule as default, moduleConfig };
